import React from 'react';
import { Alert } from '@nextiva/next-ui-components';
import { DotProgress } from 'components/DotProgress';
import styles from './AsyncAccessView.scss';

const AsyncAccessView = ({
  isLoading,
  loadingMessage,
  hasAccess,
  children,
  error,
}) => {
  return (
    <>
      {isLoading && (
        <div className={styles.asyncLoader}>
          <DotProgress />
          <div className={styles.text}>{loadingMessage}</div>
        </div>
      )}
      {!isLoading && error && (
        <div className={styles.loader}>
          <Alert severity="warning" title="Error">
            {error}
          </Alert>
        </div>
      )}
      {!isLoading && !error && hasAccess && children}
    </>
  );
};

AsyncAccessView.defaultProps = {
  loadingMessage: 'Loading settings...',
};

export default AsyncAccessView;
